module.exports = __webpack_public_path__ + "static/media/ic_pa_b4_fisdom.33002d78.svg";